export interface ITicketUserResponse {
    data: {
        id: number;
        firstName: string;
        lastName: string;
        email: string;
        password: string;
        username: string;
        centerId: number;
    }
}